import { BigButtonCard } from '@winnin/winnin_ui.components.big-button-card'
import { Button } from '@winnin/winnin_ui.components.button'
import { InputWithLabel } from '@winnin/winnin_ui.components.input-with-label'
import { TooltipWrapper } from '@winnin/winnin_ui.components.tooltip-wrapper'

import { DASHBOARD_USECASES } from 'consts/dashboardUseCases'
import { useDashboardModals } from 'contexts/DashboardModalsContext'
import { T, useTranslate } from 'lib/tolgee'
import { TOLGEE_GLOBALS } from 'utils'

import './index.scss'

const TOLGEE_PREFIX = 'CreateDashboardModalFirstStep'
const MAX_DASHBOARD_TITLE_LENGTH = 40

export default function CreateDashboardModalFirstStep() {
  const t = useTranslate()
  const { dashboard, setDashboard, setCreateDashboardStep, setIsCreateDashboardModalOpen } = useDashboardModals()

  const handleUseCaseClick = value => {
    setDashboard(prevState => ({
      ...prevState,
      useCase: value,
    }))
  }

  const handleNameChange = e => {
    setDashboard(prevState => ({
      ...prevState,
      name: e.target.value,
    }))
  }

  const handleNextButtonClick = () => {
    setCreateDashboardStep(2)
  }

  const handleCancelButtonClick = () => {
    setDashboard({})
    setIsCreateDashboardModalOpen(false)
  }

  const isNextButtonDisabled = !dashboard?.name || !dashboard?.useCase

  return (
    <div className="CreateDashboardModalFirstStep">
      <div>
        <label className="CreateDashboardModalFirstStep-label" htmlFor="dashboard-name">
          <T keyName={`${TOLGEE_PREFIX}-dashboardNameLabel`}>Nome do dashboard</T>
        </label>
        <InputWithLabel
          id="dashboard-name"
          onChange={e => handleNameChange(e)}
          value={dashboard?.name}
          placeholder={t({ key: `${TOLGEE_PREFIX}-dashboardNamePlaceholder`, defaultValue: 'Nomeie o seu dashboard' })}
          maxLength={MAX_DASHBOARD_TITLE_LENGTH}
        />
      </div>

      <div>
        <p className="CreateDashboardModalFirstStep-label">
          <T keyName={`${TOLGEE_PREFIX}-dashboardUseCaseLabel`}>Caso de uso</T>
        </p>

        <div className="CreateDashboardModalFirstStep-usecases-grid-container">
          {DASHBOARD_USECASES.map(({ label, value, description, icon, shouldHide }) => {
            if (shouldHide) {
              return null
            }
            return (
              <BigButtonCard
                key={value}
                description={t(description)}
                icon={icon}
                title={t(label)}
                isActive={dashboard?.useCase === value}
                onClick={() => handleUseCaseClick(value)}
                className="CreateDashboardModalFirstStep-big-button"
              />
            )
          })}
        </div>
      </div>

      <div className="CreateDashboardModalFirstStep-footer">
        <Button onClick={handleCancelButtonClick} variation="faded" appearance="link">
          {t(TOLGEE_GLOBALS.cancel)}
        </Button>

        <TooltipWrapper
          tooltipMessage={
            isNextButtonDisabled
              ? t({
                  key: `${TOLGEE_PREFIX}-requiredFieldsWarning`,
                  defaultValue:
                    'Para prosseguir com a criação do dashboard é necessário informar o nome e o caso de uso do mesmo',
                })
              : ''
          }
          tooltipStyle="tooltippedN"
          isTooltipMultiline
        >
          <Button onClick={handleNextButtonClick} disabled={isNextButtonDisabled}>
            {t(TOLGEE_GLOBALS.continue)}
          </Button>
        </TooltipWrapper>
      </div>
    </div>
  )
}
